import i18next from "i18next";
import React from "react";
import { Info } from "react-feather";
import Notification from "~/assets/js/components/Notification";

const ProductModifiedNotification = () => {
    return (
        <Notification
            type={"basic"}
            icon={<Info size={8} />}
            customClass="product-modified-notification"
        >
            {i18next.t("productDetails.notifications.productModified")}
        </Notification>
    );
};

export default ProductModifiedNotification;
